import appRoutes from "../../../../infrastructure/constants/appRoutes";
import reportConfigNavigation from "../../../../infrastructure/helpers/report/navigation/reportConfigNavigation";
import { htmlIds } from "../../../../infrastructure/helpers/report/navigation/reportConfigNavigation.HtmlIds";
import ComponentType from "../../../../types/report/ComponentType";

const buildText = (configName: string, componentName: string, componentType: string) => {
    return `Config: "${configName}", ${componentType.replace(/\s/g, '')}: "${componentName}"`
}

const onGlobalComponentLinkClick =(number: number, componentType: string, configId: number, innerType ?: string, mainComponentNumber ?: number)=> {

    let componentId = buildHtmlId(componentType, number, innerType, mainComponentNumber);

    let sectionName = findSectionName(componentType);

    let route = `${appRoutes.reporting.edit}?id=${configId}&htmlid=${componentId}${number? `&number=${mainComponentNumber || ''}`:''}&section=${sectionName}` || '';

    window.open(route)?.focus();
}


const buildHtmlId = (componentType: string, number: number, componentInnerType?: string, mainComponentNumber?: number): string => {
    switch (componentType) {
        case ComponentType.Aggregation: return reportConfigNavigation.buildAggregationId(number);
        case ComponentType.AggregationField: return reportConfigNavigation.buildAggregatedRecordFieldId(number);
        case ComponentType.AnnaDsbUpiSelector: return reportConfigNavigation.buildAnnaDsbUpiSelectorId(number);
        case ComponentType.AnnaDsbUpiEnrichmentSelector: return reportConfigNavigation.buildAnnaDsbUpiEnrichmentSelectorId(number);
        case ComponentType.FCARegulatedEntitiesSelector: return reportConfigNavigation.buildFCARegulatedEntitiesSelectorId(number);
        case ComponentType.Case: return reportConfigNavigation.buildCaseId(number);
        case ComponentType.CaseField: return reportConfigNavigation.buildReportFieldId(number);
        case ComponentType.Filter: return reportConfigNavigation.buildFilterId(number);
        case ComponentType.ExchangeRatesSelector: return reportConfigNavigation.buildExchangeRatesSelectorId(number);
        case ComponentType.FirdsEsmaInstrumentSelectors: return reportConfigNavigation.buildFirdsEsmaInstrumentSelectorId(number);
        case ComponentType.FirdsFcaInstrumentSelectors: return reportConfigNavigation.buildFirdsFcaInstrumentSelectorId(number);
        case ComponentType.IsinSelector: return reportConfigNavigation.buildIsinSelectorId(number);
        case ComponentType.LeiSelector: return reportConfigNavigation.buildLeiSelectorId(number);
        case ComponentType.Lookup: return reportConfigNavigation.buildLookupId(number);
        case ComponentType.OverReportFilter: return reportConfigNavigation.buildOverReportFilter(number);
        case ComponentType.UnderReportFilter: return reportConfigNavigation.buildUnderReportFilter(number);
        case ComponentType.Variable: return reportConfigNavigation.buildVariableId(number);
        case ComponentType.UserDefinedFunction: return reportConfigNavigation.buildFunctionId(number);
        case ComponentType.EndpointFilter: return reportConfigNavigation.buildEndpointFilterIdAlternative(componentInnerType || '', number);
        case ComponentType.LseSelector: return reportConfigNavigation.buildLSESelectorId(number);
        case ComponentType.SymbolSelector: return reportConfigNavigation.buildSymbolSelectorId(number);
        case ComponentType.DictionaryField: return reportConfigNavigation.buildDictionaryFieldId(number, mainComponentNumber);

        default: throw new DOMException('component type not found for function');
    }
}

const findSectionName = (componentType: string): string => {
    switch (componentType) {
        case ComponentType.Aggregation: return htmlIds.aggregations;
        case ComponentType.AggregationField: return htmlIds.aggregations;
        case ComponentType.AnnaDsbUpiSelector: return htmlIds.cacheKeys;
        case ComponentType.AnnaDsbUpiEnrichmentSelector: return htmlIds.cacheKeys;
        case ComponentType.FCARegulatedEntitiesSelector: return htmlIds.cacheKeys;
        case ComponentType.Case: return htmlIds.cases;
        case ComponentType.CaseField: return htmlIds.enrichment;
        case ComponentType.Filter: return htmlIds.filters;
        case ComponentType.ExchangeRatesSelector: return htmlIds.cacheKeys;
        case ComponentType.FirdsEsmaInstrumentSelectors: return htmlIds.cacheKeys;
        case ComponentType.FirdsFcaInstrumentSelectors: return htmlIds.cacheKeys;
        case ComponentType.IsinSelector: return htmlIds.cacheKeys;
        case ComponentType.LeiSelector: return htmlIds.cacheKeys;
        case ComponentType.Lookup: return htmlIds.lookups;
        case ComponentType.OverReportFilter: return htmlIds.expectedOverReport;
        case ComponentType.UnderReportFilter: return htmlIds.expectedUnderReport;
        case ComponentType.Variable: return htmlIds.variables;
        case ComponentType.UserDefinedFunction: return htmlIds.userDefinedFunctions;
        case ComponentType.EndpointFilter: return htmlIds.endpointFilters;
        case ComponentType.LseSelector: return htmlIds.cacheKeys;
        case ComponentType.SymbolSelector: return htmlIds.cacheKeys;
        case ComponentType.DictionaryField: return htmlIds.dictionaries;

        default: throw new DOMException('component type not found for section');
    }
}

const prepareComponentType = (componentType: string) => {

    switch (componentType) {
        case 'FCARegulatedEntitiesSelector': return ComponentType.FCARegulatedEntitiesSelector;
        case 'LSESelector': return ComponentType.LseSelector;

        default: return componentType.split(/(?=[A-Z])/).join(' ');
    }
}
export { buildText, onGlobalComponentLinkClick, prepareComponentType }

